import { useCallback, useState } from "react";
import { isPromise } from "@insightfulscience/shared-utils/fn";
import useUnmounted from "../hooks/useUnmounted";

export const FINALLY = "finally";
export const THEN = "then";
export const CATCH = "catch";

function useTracking(action, endOn = FINALLY) {
	const unmounted = useUnmounted();
	const [loading, setLoading] = useState(false);

	const end = useCallback(resOrErr => {
		if (!unmounted.current) {
			setLoading(false); // setting loading off
		}
		if (endOn === CATCH) throw resOrErr;
		return resOrErr;
	}, []);

	const trackedAction = useCallback(
		(...args) => {
			const result = action(...args);
			if (!isPromise(result)) return result;

			setLoading(true);
			return result[endOn](end);
		},
		[action],
	);

	return [trackedAction, loading];
}

export default useTracking;
